import { render } from "./ValidationQueue.vue?vue&type=template&id=72e741b2"
import script from "./ValidationQueue.vue?vue&type=script&lang=js"
export * from "./ValidationQueue.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__